import React from "react";
import cn from "classnames";
import styles from "./Trust.module.sass";

const Trust = () => {
    return (
        <div className={styles.trust}>
            <div className={cn("container", styles.container)}>
                <div className={styles.wrap}>
                    <h2 className={cn("h2", styles.title)}>
                        Trust and safety
                    </h2>
                    <div className={styles.text}>
                        At Zova, your trust is our priority. We protect your health data with end-to-end encryption, ensuring it's secure at all times. You're in control—request deletion of your data anytime, and we'll make it happen. We never share your information with third parties without your clear consent, and our systems undergo regular security audits to keep your information safe.
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Trust;